import { render, staticRenderFns } from "./FastReply.vue?vue&type=template&id=3036bdd5&scoped=true&"
import script from "./FastReply.vue?vue&type=script&lang=js&"
export * from "./FastReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3036bdd5",
  null
  
)

export default component.exports